import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { ArrowLeft } from "lucide-react";

/**
 * Reusable shell for the static legal pages: Terms, Privacy, Disclaimer.
 * Content is passed as children.
 */
export default function LegalShell({ eyebrow, title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#FAFAF7] text-slate-900">
      <Navbar />
      <div className="mx-auto max-w-3xl px-6 py-16 lg:px-10 lg:py-24">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 overline text-slate-500 hover:text-slate-900">
          <ArrowLeft className="h-3 w-3" /> Back home
        </Link>
        <div className="overline mb-3 text-[#2563EB]">{eyebrow}</div>
        <h1 className="font-serif text-4xl font-semibold leading-tight tracking-tight lg:text-5xl">
          {title}
        </h1>
        <div className="overline mt-4 text-slate-400">LAST UPDATED · {updated}</div>
        <div className="md-body mt-10">{children}</div>
      </div>
    </div>
  );
}
